import {
  ProductPriceTierCreateRequestType,
  ProductPriceTierCreateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

/** @deprecated Use useProductPriceListCreate for the canonical PriceList contract. */
export const useProductPriceTierCreate = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: ProductPriceTierCreateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `product-price-tiers`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data).data as ProductPriceTierCreateResponseType,
      ),

    onSuccess: (response) => {
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.Products, response.ProductId],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Products],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.PriceTiers],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.Products],
      });
    },
  });
};
